import { render } from "./MinusGrayIcon.vue?vue&type=template&id=4c9ff74d"
import script from "./MinusGrayIcon.vue?vue&type=script&lang=js"
export * from "./MinusGrayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__